import type { Breakpoint } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { IconButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { Iconify } from 'src/components/iconify';

const FooterRoot = styled('footer')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.vars.palette.background.default,
}));

export type FooterProps = React.ComponentProps<typeof FooterRoot>;

export function Footer({
  sx,
  layoutQuery = 'md',
  ...other
}: FooterProps & { layoutQuery?: Breakpoint }) {
  return (
    <FooterRoot sx={sx} {...other}>
      <Divider />

      <Container
        sx={(theme) => ({
          py: 2,
          textAlign: 'center',
          [theme.breakpoints.up(layoutQuery)]: { textAlign: 'unset' },
        })}
      >
        <Grid
          container
          sx={[
            {
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
            },
          ]}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            <IconButton
              onClick={() =>
                window.open('https://www.facebook.com/melfarserviceudlejning', '_blank')
              }
            >
              <Iconify width={30} icon="socials:facebook" href="" />
            </IconButton>
            <IconButton
              onClick={() =>
                window.open('https://www.instagram.com/melfarserviceudlejning/', '_blank')
              }
            >
              <Iconify width={30} icon="socials:instagram" />
            </IconButton>
          </div>

          <Typography
            sx={{ margin: '10px 0px' }}
            variant="caption"
            fontStyle="italic"
            textAlign="center"
          >
            Din lokale partner i professionel serviceudlejning <br /> - til både private og erhverv!
          </Typography>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" fontWeight={600}>
              © Melfar Serviceudlejning ApS
            </Typography>
            <Typography variant="caption">CVR: 46040686</Typography>
          </div>
        </Grid>
      </Container>
    </FooterRoot>
  );
}

// ----------------------------------------------------------------------

export function HomeFooter({ sx, ...other }: FooterProps) {
  return (
    <FooterRoot
      sx={[
        {
          py: 5,
          textAlign: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <img style={{ width: '30px' }} src="./assets/bridge.png" />
        <Box sx={{ typography: 'caption' }}>
          Melfar Serviceudlejning ApS.
          <br /> CVR: 46040686
        </Box>
      </Container>
    </FooterRoot>
  );
}
